import Vue from "vue";
import Router from "vue-router";
import Home from "@/Home";

import ElementUI, { Message } from "element-ui";
import { getToken } from "@/request/token";
import store from "@/store";
//import { checkMenuAccess } from "@/api/menu"; 作废
import { getPurePath } from "@/utils";
Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "",
      name: "Home",
      component: Home,
      children: [
        {
          path: "/",
          component: r =>
            require.ensure([], () => r(require("@/views/Index")), "index")
        },
        {
          path: "/editProject",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/project/EditProject")),
              "editProject"
            ),
          beforeEnter: (to, from, next) => {
            let hasAvatar = store.state.avatar;
            let nickname = store.state.nickname;
            let userInfoTip;
            let url;
            let flag = true;
            if (
              !hasAvatar &&
              !/^([\u4e00-\u9fa5]{1,20}|[a-zA-Z\.\s]{1,20})$/.test(nickname)
            ) {
              userInfoTip = window.vm.$i18n.t("common.userInfoTip1");
              url = "/user/myInformation";
            } else if (!hasAvatar) {
              userInfoTip = window.vm.$i18n.t("common.userInfoTip2");
              url = "/user/accountSecurity";
            } else if (
              !/^([\u4e00-\u9fa5]{1,20}|[a-zA-Z\.\s]{1,20})$/.test(nickname)
            ) {
              userInfoTip = window.vm.$i18n.t("common.userInfoTip3");
              url = "/user/myInformation";
            } else {
              next();
              flag = false;
            }
            if (flag) {
              ElementUI.MessageBox.confirm(
                userInfoTip,
                window.vm.$i18n.t("common.tips"),
                {
                  confirmButtonText: window.vm.$i18n.t("common.goTo"),
                  cancelButtonText: window.vm.$i18n.t("common.cancel"),
                  type: "warning"
                }
              )
                .then(() => {
                  // 如果用户点击了确定按钮，跳转到修改个人信息页面
                  next(url);
                })
                .catch(() => {
                  // 如果用户点击了取消按钮，阻止导航
                  next(false);
                });
            }
          },
          meta: { requireLogin: false }
        },
        {
          path: "/postProject",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/project/PostProject")),
              "postProject"
            ),
          meta: { requireLogin: true }
        },
        {
          path: "/myProject",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/project/MyProject")),
              "myProject"
            ),
          meta: { requireLogin: true }
        },
        {
          path: "/MyCollection",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/collection/MyCollection")),
              "MyCollection"
            ),
          meta: { requireLogin: true }
        },
        {
          path: "/projectView",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/project/ProjectView")),
              "ProjectView"
            ),
          meta: { requireLogin: false }
        },
        {
          path: "/projectDispute",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/project/projectDispute")),
              "ProjectDispute"
            ),
          // children: [
          //   {path: 'one',component: r => require.ensure([], () => r(require('@/views/project/projectDispute/DisputeOne')),'DisputeOne')},
          //   {path: 'two',component: r => require.ensure([], () => r(require('@/views/project/projectDispute/DisputeTwo')),'DisputeTwo')},
          //   {path: 'three',component: r => require.ensure([], () => r(require('@/views/project/projectDispute/DisputeThree')),'DisputeThree')},
          //   {path: 'four',component: r => require.ensure([], () => r(require('@/views/project/projectDispute/DisputeFour')),'DisputeFour')},
          // ],
          meta: {
            requireLogin: false
          }
        },
        {
          path: "/TradeView",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/project/TradeView")),
              "tradeView"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/bidProjectView",
          name: "BidProjectView",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/project/BidProjectView")),
              "bidProjectView"
            ),
          meta: {
            requireLogin: false
          }
        },
        {
          path: "/postProjectSuccess",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/project/PostProjectSuccess")),
              "postProjectSuccess"
            ),
          meta: {
            requireLogin: false
          }
        },

        {
          path: "/myProfile",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/user/MyProfile")),
              "myProfile"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/editProfile",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/user/EditProfile")),
              "editProfile"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/user/myInformation",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/user/MyInformation")),
              "myInformation"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/user/EditingInformation",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/user/EditingInformation")),
              "EditingInformation"
            ),
          meta: {
            requireLogin: true
          }
        },

        {
          path: "/user/withdrawal",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/user/Withdrawal")),
              "Withdrawal"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/user/notificationSettings",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/user/notificationSettings")),
              "Notificationsettings"
            ),
          meta: {
            requireLogin: true
          }
        },

        {
          path: "/user/accountSecurity",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/user/AccountSecurity")),
              "accountSecurity"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/user/myBankCard",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/user/MyBankCard")),
              "myBankCard"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/user/addBankCard",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/user/AddBankCard")),
              "AddBankCard"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/updatePass",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/user/UpdatePass")),
              "updatePass"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/u/:nickname",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/user/HisProfile")),
              "hisProfile"
            ),
          meta: {
            requireLogin: false
          }
        },
        {
          path: "/mySettings",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/user/MySettings")),
              "mySettings"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/msgCenter",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/message/MsgCenter")),
              "msgCenter"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/socketMsg",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/message/SocketMsg")),
              "socketMsg"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/adminHome",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/admin/home")),
              "adminHome"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/userStatistics",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/admin/userStatistics")),
              "userStatistics"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/userDetails",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/admin/userDetails")),
              "userDetails"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/avatarExamine",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/admin/AvatarExamine")),
              "avatarExamine"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/adminOrder",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/admin/order")),
              "adminOrder"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/admin/buyerStatement",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/admin/buyerStatement")),
              "buyerStatement"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/admin/buyerBill",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/admin/buyerBill")),
              "buyerBill"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/admin/sellerStatement",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/admin/sellerStatement")),
              "sellerStatement"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/admin/withdrawalApproval",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/admin/withdrawalApproval")),
              "withdrawalApproval"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/admin/withdrawalRecord",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/admin/withdrawalRecord")),
              "withdrawalRecord"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/admin/withdrawalRecordDetails",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/admin/withdrawalRecordDetails")),
              "withdrawalRecordDetails"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/admin/sellerBill",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/admin/sellerBill")),
              "sellerBill"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/admin/feedback",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/admin/feedback")),
              "feedback"
            ),
          meta: {
            requireLogin: true
          }
        },

        {
          path: "/admin/helpDetails",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/admin/helpDetails")),
              "helpDetails"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/admin/helpCenter",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/admin/helpCenter")),
              "helpCenter"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/admin/autoQAndASetting",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/admin/autoQAndASetting")),
              "autoQAndASetting"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/bill/myStatement",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/bill/myStatement")),
              "myStatement"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/bill/myBill",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/bill/myBill")),
              "myBill"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/pointsOrder",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/admin/pointsOrder")),
              "pointsOrder"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/pointsBasics",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/admin/pointsBasics")),
              "pointsBasics"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/platformFeeManagement",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/admin/platformFeeManagement")),
              "platformFeeManagement"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/arbitrationManagement",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/admin/arbitrationManagement")),
              "arbitrationManagement"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/authManagement",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/admin/authManagement")),
              "authManagement"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/homePageSetting",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/admin/homePageSetting")),
              "homePageSetting"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/vipBasics",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/admin/vipBasics")),
              "vipBasics"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/vipOrder",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/admin/vipOrder")),
              "vipOrder"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/systemMsg",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/admin/systemMsg")),
              "systemMsg"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/admin/systemContent/editSystemContent",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/admin/subPage/editSystemContent")),
              "editSystemContent"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/admin/systemContent",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/admin/systemContent")),
              "systemContent"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/projectManagement",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/admin/projectManagement")),
              "projectManagement"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/admin/projectManagement/projectViewToAdmin",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/admin/subPage/projectViewToAdmin")),
              "projectViewToAdmin"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/timedTask",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/admin/timedTask")),
              "timedTask"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/myPoints",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/points/myPoints")),
              "myPoints"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/withdrawal/recharge",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/recharge/recharge")),
              "recharge"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/vipCenter",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/vip/vipCenter")),
              "vipCenter"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/about/operationGuidance",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/about/OperationGuidance")),
              "operationGuidance"
            ),
          meta: {
            requireLogin: false
          }
        },
        {
          path: "/about/content",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/about/Content")),
              "Content"
            ),
          meta: {
            requireLogin: false
          }
        },
        {
          path: "/admin/skillsSettings",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/admin/skillsSettings")),
              "skillsSettings"
            ),
          meta: {
            requireLogin: true
          }
        },
        {
          path: "/searchProject",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/search/searchProject")),
              "searchProject"
            ),
          meta: {
            requireLogin: false
          }
        },
        {
          path: "/searchTalent",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/search/searchTalent")),
              "searchTalent"
            ),
          meta: {
            requireLogin: false
          }
        },
        {
          path: "/about/withdrawalAgreement",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/about/withdrawalAgreement")),
              "withdrawalAgreement"
            ),
          meta: {
            requireLogin: false
          }
        },
        {
          path: "/help",
          component: r =>
            require.ensure([], () => r(require("@/views/help/help")), "help"),
          meta: {
            requireLogin: false
          }
        },
        {
          path: "/help/results",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/help/results")),
              "results"
            ),
          meta: {
            requireLogin: false
          }
        },
        {
          path: "/help/article",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/help/article")),
              "article"
            ),
          meta: {
            requireLogin: false
          }
        },

        {
          path: "/auth",
          component: r =>
            require.ensure(
              [],
              () => r(require("@/views/auth/center")),
              "AuthCenter"
            ),
          meta: {
            requireLogin: true
          }
        }
      ]
    },
    {
      path: "/login",
      name: "login",
      component: r =>
        require.ensure([], () => r(require("@/views/Login")), "login")
    },
    {
      path: "/pay/payResult",
      component: r =>
        require.ensure(
          [],
          () => r(require("@/views/pay/PayResult")),
          "PayResult"
        )
    },
    {
      path: "/register",
      component: r =>
        require.ensure([], () => r(require("@/views/Register")), "register")
    },
    {
      path: "/BeforeRegister",
      component: r =>
        require.ensure(
          [],
          () => r(require("@/views/BeforeRegister")),
          "beforeRegister"
        )
    },

    {
      path: "/retrievePass",
      component: r =>
        require.ensure(
          [],
          () => r(require("@/views/RetrievePass")),
          "retrievePass"
        )
    },
    {
      path: "/resetPassword",
      component: r =>
        require.ensure(
          [],
          () => r(require("@/views/resetPassword")),
          "resetPassword"
        )
    },
    {
      path: "/agreement",
      component: r =>
        require.ensure([], () => r(require("@/views/Agreement")), "agreement")
    },
    {
      path: "/admin/chattingOnline",
      component: r =>
        require.ensure(
          [],
          () => r(require("@/views/admin/chattingOnline")),
          "chattingOnline"
        ),
      meta: {
        requireLogin: true
      }
    },
    {
      path: "/message/chatOnline",
      component: r =>
        require.ensure(
          [],
          () => r(require("@/views/message/chatOnline")),
          "chatOnline"
        ),
      meta: {
        requireLogin: false
      }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    };
  }
});

//获取权限和菜单列表
async function getMenuListAndPermision(){
  await store.dispatch("getPermissionList");
  await store.dispatch("getMenuList");
}

router.beforeEach(async (to, from, next) => {
  //先获取权限和菜单列表
  await getMenuListAndPermision();
  if (to.matched.some(r => r.meta.requireLogin)) {
    // 需要登录才能访问
    if (getToken()) {
      // 有token, 已登录
      // // 检查用户是否有权限访问该路由
      // checkMenuAccess(to.path).then(res => {
      //   if (res.data) { // 有权限
      //     console.log('有权限',res)
      //     next()
      //   } else { // 无权限,
      //     console.log('无权限',res)
      //     next({
      //       path: '/'
      //     })
      //   }
      // })
      // 从oc检查用户是否有权限访问该路由,历史原因，忽略大小写
      if(store.state.webPaths.some(item => getPurePath(to.path).toLowerCase() == item.toLowerCase())){
        console.log('有权限',to.path)
        next()
      }else{
        console.log('无权限',to.path)
        next({path: '/'})
      }
      // next();
    } else {
      // 无token, 未登录
      next({ path: "/login" });
    }
  } else {
    // 不需要登录的页面直接放行
    next();
  }
});



export default router;




// WEBPACK FOOTER //
// ./src/router/index.js